import request from '../../utils/request'

export function fetchList (data) {
  return request.post('/business/driverInfo/page', data, {
    trim: true
  })
}
export function paidDepositList () {
  return request.get('/business/driverInfo/paidDepositList')
}
export function getById (id) {
  return request.get(`/business/driverInfo/detail/${id}`)
}

export function updateStatus (data) {
  return request.post('/business/driverInfo/updateStatus', data, {
    trim: true
  })
}

export function exportExcel (data) {
  return request.post('/business/driverInfo/exportExcel', data, {
    download: true,
    trim: true
  })
}

export function audit (data) {
  return request.post('/business/driverInfo/audit', data, {
    trim: true
  })
}
